import { render } from "./VisitList.vue?vue&type=template&id=447c2a4e&ts=true"
import script from "./VisitList.vue?vue&type=script&lang=ts"
export * from "./VisitList.vue?vue&type=script&lang=ts"

import "./VisitList.vue?vue&type=style&index=0&id=447c2a4e&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__